import { store, authActions } from "../_store";
import StackTrace from "stacktrace-js";
import { history } from "./history";
import { getStoredValue } from "./storagehelper";
export const fetchWrapper = {
  get: request("GET"),
  post: request("POST"),
  put: request("PUT"),
  delete: request("DELETE"),
};

const getBrowserType = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes("Firefox")) {
    return "Firefox";
  } else if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
    return "Chrome";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    return "Safari";
  } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
    return "Opera";
  } else if (userAgent.includes("Trident")) {
    return "Internet Explorer";
  } else if (userAgent.includes("Edg")) {
    return "Edge";
  }
  else if (userAgent.indexOf("Edg/") > -1) {
    return "Edge";
  } else if (
    userAgent.indexOf("OPR/") > -1 ||
    userAgent.indexOf("Opera") > -1
  ) {
    return "Opera";
  } else if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  } else if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  } else if (userAgent.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (
    userAgent.indexOf("Trident") > -1 ||
    userAgent.indexOf("MSIE") > -1
  ) {
    return "Internet Explorer";
  } else {
    return "Unknown";
  }

};

function request(method) {
  return (url, body, options = {}) => {
    const headers = {
      ...authHeader(url),
      "X-Client-IP": getStoredValue("cachedIP"),
      "X-Client-Browser": getBrowserType(),
      "X-Client-URL": window.location.href,
    };
    const requestOptions = {
      method,
      headers,
    };

    if (body) {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(body);
    }

    return fetch(url, requestOptions)
      .then((response) => {
        if (options.isFile) {
          if (!response.ok) {
            throw new Error("Failed to download file");
          }
          return response.blob(); // Return blob directly
        } else {
          return handleResponse(response, method, body); // default JSON logic
        }
      })
      .catch(async (error) => {
        logErrorToServer(error, url, method, body);
        // Re-throw the error after logging
        throw error;
      });
  };
}

async function logErrorToServer(error, url, method, body) {
  try {
    const stackFrames = await StackTrace.fromError(error);
    const frame = stackFrames[0] || {};
    const fileName = "File name: " + (frame?.fileName || "Unknown");
    const lineNumber = "Line number: " + (frame?.lineNumber || "Unknown");
    const methodInfo = method || "N/A";
    const requestBody = body ? JSON.stringify(body) : "No body";

    const requestContext = `Method: ${methodInfo} | URL: ${url} | Body: ${requestBody} | Function Name: ${frame?.functionName || "Unknown"} | ${fileName}, ${lineNumber}`;

    const errorLog = {
      Message: `${error?.message} | Date and Time: ${new Date().toISOString()}`,
      StackTrace: `${error?.stack || "Unknown"}`,
      CurrentURL: window.location.href,
      TargetSite: url,
      Source: `${error?.source || frame?.source || "Unknown"} | ${requestContext}`,
      IPAddress: getStoredValue("cachedIP") || "Unknown",
      Browser: getBrowserType(),
    };

    await fetch(`${process.env.REACT_APP_API_URL}/ErrorLog/logs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        path: "Logs/CreateErrorLog",
        errorLog: JSON.stringify(errorLog),
      }),
    });
  }
  catch (e) {

    const msg = e?.message || "";

    // Safari Refresh issue 
    if (msg == "Cannot parse given Error object") return;

    localStorage.setItem("ErrorMessage", msg);

    history.navigate('/Admin/Error');
  }
}


// helper functions

function authHeader(url) {
  // return auth header with jwt if user is logged in and request is to the api url
  const token = authToken();
  const userTokenFromLocalStorage = getStoredValue("user");
  const isLoggedIn = !!token;
  const isApiUrl = url.startsWith(process.env.REACT_APP_API_URL);
  if (isLoggedIn && isApiUrl && userTokenFromLocalStorage !== "") {
    return { Authorization: `Bearer ${token}` };
  } else {
    const logout = () => store.dispatch(authActions.logout());
    logout();
    history?.navigate("/facilityUser");
    return {};
  }
}

function authToken() {
  return store.getState().auth.user?.Token;
}

function handleResponse(response, method, body) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      try {
        // Log the error to the server
        const errorData = {
          message: `type : ${response?.type} | Status Code : ${response?.status
            } (${response?.statusText || "No status text"})`,
        };
        const fileName = "File name: fetch-wrapper.js";
        const lineNumber = "Line number: 118";
        const methodInfo = method || "N/A";
        const requestBody = body ? JSON.stringify(body) : "No body";

        const requestContext = `Method: ${methodInfo} | URL: ${response?.url} | Body: ${requestBody} | Function Name: handleResponse  | ${fileName}, ${lineNumber} `;
        const errorLog = {
          Message: `${errorData?.message
            }  | Date and Time: ${new Date().toISOString()}`,
          StackTrace: `Unknown`,
          CurrentURL: window.location.href,
          TargetSite: response?.url,
          Source: requestContext,
          IPAddress: getStoredValue("cachedIP") || "Unknown",
          Browser: getBrowserType(),
        };
        // Send error to the logging API (adjust the URL as needed)
        return fetch(`${process.env.REACT_APP_API_URL}/ErrorLog/logs`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            path: "Logs/CreateErrorLog",
            errorLog: JSON.stringify(errorLog),
          }),
        });
      } catch (e) {
        console.error("Error parsing response text:", e);
      }
      if ([401, 403].includes(response.status) && authToken()) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        const logout = () => store.dispatch(authActions.logout());
        logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
